import { Loader2 } from 'lucide-react'

import { Button } from '@/modules/shared/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/modules/shared/components/ui/dialog'
import { Input } from '@/modules/shared/components/ui/input'

import { useModalLoadExcelComponent } from '../../../hooks/use-modal-load-excel-component.hook'

export function ModalLoadExcelComponent() {
  const {
    handleChangeFile,
    handleCloseModalLoadExcel,
    handleUpload,
    isLoading,
    isOpenModalLoadExcel,
  } = useModalLoadExcelComponent()

  return (
    <Dialog
      open={isOpenModalLoadExcel}
      onOpenChange={handleCloseModalLoadExcel}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Carregar excel</DialogTitle>
        </DialogHeader>
        {!isLoading && <DialogClose />}

        <Input
          type="file"
          onChange={(event) => handleChangeFile(event)}
          accept=".xlsx"
        />

        <DialogFooter>
          <Button onClick={handleUpload} disabled={isLoading}>
            {isLoading && <Loader2 size={16} className="animate-spin mr-3" />}
            Salvar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
